import React from 'react';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

export const qualityPlugin = createFrontendPlugin({
  pluginId: 'quality',
  extensions: [
    PageBlueprint.make({
      name: 'center',
      params: {
        path: '/quality/:namespace/:kind/:name',
        title: 'Quality Center',
        noHeader: true,
        loader: () =>
          import('./pages').then(m =>
            React.createElement(m.QualityCenterPage),
          ),
      },
    }),
  ],
});
